import React, { useEffect } from 'react'
import AriaModal from 'react-aria-modal'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

export default function ConfirmationModal ({ closeModal, finishOrder, selectedDiscount, pointsName }) {
  useEffect(() => {
    const modalContainer = document.getElementById('confirmationCreditModal')
    if (modalContainer) {
      setTimeout(() => {
        modalContainer.focus()
      }, 500)
    }
  }, [])
  return (
    <AriaModal
      titleText='Confirmação do resgate'
      onExit={closeModal}
      focusDialog='false'
      underlayStyle={{ zIndex: 9999 }}
      // initialFocus='#confirmationCreditModal'
    >
      <div data-campaign={process.env.REACT_APP_CATALOG_ID}
        className='confirmation-modal-invoice-credit col-12 col-md-9 h-100 radius border-bottom-lg border-color-featured bg-white pb-1 p-0 mr-auto ml-auto'
        id='confirmationCreditModal'
        tabIndex={0}
      >
        <h1 className='border-bottom border-color-ui-2 px-2 py-3'>Confirmação do resgate</h1>

        {process.env.REACT_APP_IUPP_INVOICE_CREDIT && (
          <div className='p-2 color-ui-2'>
            <p aria-hidden='true' className='text-font-body'>
              Você está resgatando <strong className='txt-body-sm color-brand-4'>{selectedDiscount.points || 0} {pointsName} iupp </strong>
              que serão convertidos em <strong className='txt-body-sm color-brand-4'>R$ {numberToStrCurrency(selectedDiscount !== null ? selectedDiscount.credit : 0, 2)} de créditos </strong>
              na sua fatura Itaucard.
            </p>
            <span className='hide-absolute'>{`Você está resgatando ${selectedDiscount.points || 0} ${pointsName} iupp que serão convertidos em R$ ${numberToStrCurrency(selectedDiscount !== null ? selectedDiscount.credit : 0, 2)} de créditos na sua fatura Itaucard.`}</span>
          </div>
        )}
        <div className='pb-2 pl-2 color-ui-2'>
          <p>Deseja confirmar o resgate?</p>
        </div>

        <div className='d-flex px-1 flex-wrap flex-md-wrap-reverse '>
          <div className='col-12 col-md-6 px-1'>
            <Button
              id='btn-cancel-credit'
              name='btn-cancel-credit'
              className='btn txt-button txt-font-body'
              text='Cancelar'
              onClick={closeModal}
              role='button'
              tabIndex={0}
            />
          </div>
          <div className='col-12 col-md-6 px-1 mt-2 mt-md-0'>
            <Button
              id='btn-submit-credit'
              name='btn-submit-credit'
              className='btn btn-featured btn-rating-modal2 txt-button txt-font-body'
              text='Confirmar resgate'
              onClick={() => {
                finishOrder()
                closeModal()
              }}
              role='button'
              tabIndex={0}
            />
          </div>
        </div>
      </div>
    </AriaModal>
  )
}

ConfirmationModal.propTypes = {
  closeModal: PropTypes.func,
  finishOrder: PropTypes.func,
  selectedDiscount: PropTypes.object,
  pointsName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/ConfirmationModal.js